import React from "react";
import { Chip, Tooltip, Typography, useTheme } from "@mui/material";
import { AccountBox, DirectionsCar, EvStation, EventSeat, LocalParking } from "@mui/icons-material";
import { useSelector } from "../../../app/helpers";
import { RootState } from "../../../app/rootReducer";
import { BookingType } from "../../../features/Booking-Form/typings/booking-inputs";
import { ReactComponent as ConferenceIconComp } from "../../../features/Booking-Form/assets/conference.svg";

export const SvgReportHeaderChips = ({
  tooltip,
  label,
  icon
}: {
  tooltip: string;
  label: number | string;
  icon?: BookingType | "users";
}) => {
  const {
    userInformation: {
      company: { meta }
    }
  } = useSelector((state: RootState) => state.login);

  const chipSxStyle = {
    fontSize: "15px",
    marginLeft: 0.1,
    marginRight: 0.1
  };
  const iconStyle = { width: "22px" };

  const generateIcon = (icon?: string) => {
    switch (icon) {
      case "users":
        return <AccountBox sx={iconStyle} />;
      case BookingType.WORKPLACE:
        return <EventSeat sx={iconStyle} />;
      case BookingType.PARKINGPLACE:
        return <LocalParking sx={iconStyle} />;
      case BookingType.ELECTRICCHARGINGSTATIONPLACE:
        return <EvStation sx={iconStyle} />;
      case BookingType.VEHICLE:
        return <DirectionsCar sx={iconStyle} />;
      case BookingType.CONFERENCEZONE:
        return (
          <StyledComponent metaColor={meta.color ?? "#32D79B"}>
            <ConferenceIconComp width={"22px"} height={"22px"} />
          </StyledComponent>
        );
      default:
        return undefined;
    }
  };
  return (
    <Tooltip title={<Typography>{tooltip}</Typography>} aria-label={tooltip}>
      <Chip
        data-testid={`${tooltip}-header-chip`}
        icon={generateIcon(icon)}
        size={"medium"}
        label={label}
        sx={{ ...chipSxStyle }}
        color={"primary"}
      />
    </Tooltip>
  );
};
interface StyledSVGIconProps extends React.SVGProps<SVGSVGElement> {
  width?: string;
  height?: string;
  marginLeft?: string | number;
  marginRight?: string | number;
  metaColor: string;
}

/**
 * Wrap any imported SVG ReactComponent and apply theme-based fill
 * + optional width, height, margin
 */
export function StyledComponent({
  children,
  width = "22px",
  height = "22px",
  marginLeft,
  marginRight,
  style,
  metaColor,
  ...rest
}: StyledSVGIconProps & { children: React.ReactElement }) {
  const theme = useTheme();
  // create temp theme to convert conference icon color
  const tempTheme = {
    ...theme,
    palette: { text: { primary: theme.palette.getContrastText(metaColor) } }
  };

  return React.cloneElement(children, {
    ...rest,
    width,
    height,
    style: {
      ...style,
      marginLeft,
      marginRight,
      "& path": {
        fill: tempTheme.palette.text.primary
      }
    }
  });
}
